<template>
  <TableGradient
      icon-name="industry"
      :title="$t('manufacturer.listagem.titulo_pagina')"
      :text-empty="$t('manufacturer.listagem.table.empty')"
      route-new="vns.manufacturer.create"
      :text-new="$t('manufacturer.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="manufacturers"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('manufacturer/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`"
                   :to="{ name: 'vns.manufacturer.edit', params: { id: linha.item.id }}" class="font-weight-bold">
        {{ $t('manufacturer.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      manufacturers: 'manufacturer/all',
      paginator: 'manufacturer/pagination',
      store_isLoading: 'manufacturer/isLoading',
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('manufacturer.listagem.table.nome'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('manufacturer.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('manufacturer.listagem.table.nome')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'manufacturer/listAll'
    ])
  },
  mounted() {
    this['manufacturer/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
